export default __webpack_public_path__ + "static/media/warning.46302270.png";